export interface LayoutState {
    isCollapsed: boolean;
    isSmallScreen: boolean;
    isOverlay: boolean;
}

export const initialLayoutState: LayoutState = {
    isCollapsed: false,
    isSmallScreen: false,
    isOverlay: false,
};
